import {
  GetApiTimesheetsByUuidEntriesError,
  GetApiTimesheetsByUuidEntriesResponse,
  GetApiTimesheetsByUuidEntriesVariables,
  useGetTimesheetEntries as useGetApiTimesheetEntries,
} from '@sit/client-shared';
import { QueryKey, SkipToken, skipToken, UseQueryOptions } from '@tanstack/react-query';

export function useGetTimesheetEntries<TData = GetApiTimesheetsByUuidEntriesResponse>(
  variables: GetApiTimesheetsByUuidEntriesVariables | SkipToken,
  options?:
    | Omit<
        UseQueryOptions<GetApiTimesheetsByUuidEntriesResponse, GetApiTimesheetsByUuidEntriesError, TData, QueryKey>,
        'queryKey' | 'queryFn' | 'initialData'
      >
    | undefined,
) {
  return useGetApiTimesheetEntries(
    variables === skipToken
      ? skipToken
      : {
          pathParams: variables.pathParams,
          queryParams: {
            ...variables.queryParams,
            includeAllocationChildren: true,
          },
        },
    options,
  );
}
